import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ContactUsModal = ({ show, onHide, showNotification }) => {
  const [organizationName, setOrganizationName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [purpose, setPurpose] = useState('');
  const [numPeople, setNumPeople] = useState('');
  const [location, setLocation] = useState(''); // New state for location
  const [moreInfo, setMoreInfo] = useState('');
  const [validated, setValidated] = useState(false); // State for form validation

  const getUserLocation = async () => {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      return `${data.city}, ${data.region}, ${data.country_name}`;
    } catch (error) {
      console.error("Error fetching location:", error);
      return '';
    }
  };

  useEffect(() => {
    if (show && !location) {
      getUserLocation().then(loc => {
        setLocation(loc);
      });
    }
    // Reset validation when modal is shown
    if (show) {
      setValidated(false);
    }
  }, [show]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const payload = {
        organizationName,
        phoneNumber,
        email,
        purpose,
        numPeople,
        location,
        moreInfo,
      };
      console.log("Contact Form Payload:", JSON.stringify(payload, null, 2));
      showNotification("Thank you for contacting us! We will get back to you shortly."); // Show notification
      onHide(); // Close modal after submission
      // Reset form fields
      setOrganizationName('');
      setPhoneNumber('');
      setEmail('');
      setPurpose('');
      setNumPeople('');
      setLocation('');
      setMoreInfo('');
      setValidated(false); // Reset validation state
    }
    setValidated(true); // Set validated to true to show validation feedback
  };

  const purposeOptions = [
    "Product Inquiry",
    "Partnership",
    "Support",
    "Press",
    "Other",
  ];

  const numPeopleOptions = [
    "1-10",
    "11-50",
    "51-200",
    "201-500",
    "501-1000",
    "1000+",
  ];

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="lg" 
      backdrop="static"
      className="chatbot-modal"
    >
      <Modal.Header 
        closeButton 
        style={{
          backgroundColor: '#f6f1e7',
          borderBottom: 'none'
        }}
      >
        <Modal.Title className="d-flex align-items-center" style={{ gap: '12px' }}>
          <div style={{
            width: "32px",
            height: "32px",
            background: "linear-gradient(145deg, rgba(34, 34, 34, 0.9), #000000)",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: "15px",
            fontWeight: "700",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
          }}>
            L
          </div>
          <div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>
              Book a Demo
            </div>
            <div style={{ fontSize: '12px', color: '#666', fontWeight: '400' }}>
              Connect with a Libertus AI Expert
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body 
        className="d-flex flex-column" 
        style={{
          height: 'clamp(400px, 70vh, 600px)',
          maxHeight: '600px',
          overflowY: 'auto',
          padding: 'clamp(16px, 4vw, 24px)',
        }}
      >
        <Form id="contact-form" noValidate validated={validated} onSubmit={handleSubmit} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <Form.Group controlId="formOrganizationName">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>Organization Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your organization's name"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
              required
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            />
            <Form.Control.Feedback type="invalid">Please enter your organization's name.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formPhoneNumber">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>Phone Number</Form.Label>
            <Form.Control
              type="tel"
              placeholder="Enter your phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              pattern="^(\+\d{1,3}[- ]?)?\d{10}$"
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            />
            <Form.Control.Feedback type="invalid">Please enter a valid 10-digit phone number (e.g., +1-555-123-4567 or 5551234567).</Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formEmail">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            />
            <Form.Control.Feedback type="invalid">Please enter a valid email address.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formPurpose">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>Purpose</Form.Label>
            <Form.Select
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
              required
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            >
              <option value="">Select Purpose</option>
              {purposeOptions.map((opt, index) => (
                <option key={index} value={opt}>{opt}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">Please select a purpose.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formNumPeople">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>Number of People in Organization</Form.Label>
            <Form.Select
              value={numPeople}
              onChange={(e) => setNumPeople(e.target.value)}
              required
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            >
              <option value="">Select Number of People</option>
              {numPeopleOptions.map((opt, index) => (
                <option key={index} value={opt}>{opt}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">Please select the number of people.</Form.Control.Feedback>
          </Form.Group>

          {/* New Location Field */}
          <Form.Group controlId="formLocation">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>Location</Form.Label>
            <Form.Control
              type="text"
              placeholder="Auto-populated or enter your location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              required
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            />
            <Form.Control.Feedback type="invalid">Please enter your location.</Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formMoreInfo">
            <Form.Label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '5px' }}>More Information</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Tell us more about your needs..."
              value={moreInfo}
              onChange={(e) => setMoreInfo(e.target.value)}
              style={{
                borderRadius: '16px',
                border: '1px solid #ddd',
                padding: '10px 15px',
                fontSize: '15px',
                backgroundColor: '#ffffff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                fontFamily: 'inherit'
              }}
            />
          </Form.Group>

          {/* Buttons moved to footer */}
        </Form>
      </Modal.Body>
      <Modal.Footer className="modal-footer-themed" style={{ 
        backgroundColor: '#f6f1e7',
        borderTop: '1px solid rgba(26, 26, 26, 0.05)',
        padding: '20px 30px',
        justifyContent: 'flex-end',
        gap: '10px'
      }}>
        <Button variant="secondary" onClick={onHide} style={{ backgroundColor: 'transparent', border: '1px solid #ccc', color: '#666', borderRadius: '30px', padding: '10px 25px', fontWeight: '500', transition: 'all 0.2s ease' }}>
          Cancel
        </Button>
        <Button variant="primary" type="submit" form="contact-form" style={{ backgroundColor: '#1a1a1a', border: 'none', color: '#f6f1e7', borderRadius: '30px', padding: '10px 25px', fontWeight: '500', transition: 'all 0.2s ease' }}>
          Submit
        </Button>
      </Modal.Footer>
      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(15px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </Modal>
  );
};

export default ContactUsModal;
